import { Text } from '@/components/Text';
import { ReactNode } from 'react';

interface FormCardProps {
  children: ReactNode;
  title: string;
}

export const FormCard = ({ children, title }: FormCardProps) => {
  return (
    <div className=" w-full max-w-md rounded-xl bg-white p-3  md:p-5">
      <Text className="mb-3 text-center text-xl font-bold text-sky-900 md:mb-4 md:text-2xl">
        {title}
      </Text>
      {children}
    </div>
  );
};
